<template>
    <b-modal 
      id="identity-modal"
      size="lg"
      centered 
      :title="!firefoxLinkStep? 'Merci de renseigner les informations suivantes avant d\'accéder à votre certificat.' : 'Merci pour vos réponses.'" 
      title-class="text-center w-100"
      header-bg-variant="primary" 
      header-text-variant="light"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :ok-only="true"
      ok-title="Confirmer"
      ok-variant="secondary"
    >
        <div class="alert alert-primary" style="font-size:0.9rem;" v-if="!firefoxLinkStep">
            Depuis le 1er juillet 2021, chaque français bénéficie d'un « Passeport d'orientation, de formation et de compétences ». Ce passeport recense l'ensemble des diplômes et certifications obtenus et garantit ainsi leur authenticité (<b-link href="https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000038951755" target="_blank">L. 6323-8 du code du travail</b-link>). <br>
            Dans le cadre de ce dispositif gratuit, et en tant qu’organisme certificateur, nous sommes dans l’obligation de recueillir et de vérifier des informations vous concernant (nom, prénom, date et lieu de naissance). <br>
            Ces informations obligatoires sont confidentielles et ne seront jamais utilisées à des fins commerciales.
        </div>

        <b-form-group  v-if="step == 'full_name'">
            <b-form-group
            label="Genre :"
            label-for="gender"
            >
            <b-form-select name="gender" v-model="form.full_name.gender" :state="(form.full_name.gender=='MALE' || form.full_name.gender=='FEMALE')? null : false" :options="genderOptions" required>
                <template #first>
                <b-form-select-option :value="null" disabled>Veuillez sélectionner l'une des propositions</b-form-select-option>
                </template>
            </b-form-select>
            </b-form-group>
            <b-form-group
            label="Nom d'usage :"
            label-for="last-name"
            >
            <b-form-input
                id="last-name"
                type="text"
                v-model="form.full_name.last_name"
                placeholder="Veuillez renseigner votre nom"
                :state="(form.full_name.last_name.trim()!='')? null : false"
            ></b-form-input>
            </b-form-group>
            <b-form-group
            label="Nom de naissance (obligatoire, si différent de votre nom d'usage) :"
            label-for="birth-name"
            >
            <b-form-input
                id="birth-name"
                type="text"
                v-model="form.full_name.birth_name"
            ></b-form-input>
            </b-form-group>
            <b-form-group
            label="Prénom :"
            label-for="first-name"
            >
            <b-form-input
                id="first-name"
                type="text"
                v-model="form.full_name.first_name"
                placeholder="Veuillez renseigner votre prénom"
                :state="(form.full_name.first_name.trim()!='')? null : false"
            ></b-form-input>
            <p class="text-center mt-2 mb-0" style="font-size:0.9rem;">Les modifications seront traitées dans un délai de 72h.</p>
            <b-container class="mt-3">
                <div v-if="isLoading" class="d-flex justify-content-center mb-3">
                  <b-spinner variant="primary"></b-spinner>
                </div>
                <b-row v-else align-h="between">
                <b-col cols="5" class="p-0 m-0">
                    <b-button variant="danger" class="close-identity-modal w-100"  @click="$bvModal.hide('identity-modal')">Annuler</b-button>
                </b-col>
                <b-col cols="5" class="p-0 m-0">
                    <b-button id="confirm-full-name" variant="secondary" :disabled="form.full_name.first_name=='' || form.full_name.last_name=='' || (form.full_name.gender != 'MALE' && form.full_name.gender != 'FEMALE')" @click="checkFullName" class="w-100">Confirmer ces informations 1/2</b-button>
                </b-col>
                </b-row>
            </b-container>
            </b-form-group>
        </b-form-group>

        <b-form-group v-if="step == 'birth' && !firefoxLinkStep">
          <b-form-group
            label="Date de naissance :"
            label-for="birth-date"
          >
            <b-form-input
              v-if="browser!='Safari' && browser!='IE'"
              id="birth-date"
              v-model="form.birth.birth_date"
              type="date"
              :state="birthDateFilled==true? null : false"
            ></b-form-input>
            <b-form-input 
              v-else
              id="alternative-birth-date" 
              v-model="alternative_birth_date" 
              placeholder="jj/mm/aaaa" 
              size=10
              maxlength=10
              onkeydown="this.value=this.value.replace(/^(\d\d)(\d)$/g,'$1/$2').replace(/^(\d\d\/\d\d)(\d+)$/g,'$1/$2').replace(/[^\d\/]/g,'')"
              :state="birthDateFilled==true? null : false"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Lieu de naissance :"
            label-for="birthplace"
          >
            <b-container class="mb-1">
                <b-row>
                  <b-col align="center">
                    <b-form-radio v-model="country" name="country-radios" @change="clearBirthPlace" value="france">France</b-form-radio>
                  </b-col>
                  <b-col align="center">
                    <b-form-radio v-model="country" name="country-radios" @change="clearBirthPlace" value="hors-france">Hors France</b-form-radio>
                  </b-col>
                </b-row>
            </b-container>            
            <v-select
              id="select_birthplace"
              :class="'form-control '+emptyBirthPlaceClass"
              label="text" 
              v-model="form.birth.birthplace" 
              :options="birthplace_list"
              :placeholder="birthplace_search_placeholder"
              @search="getInseeList"
              :filterable="false"
              :state="birthPlaceFilled==true? null : false"
            >
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  Aucun résultat trouvé pour la recherche <em>{{ search }}</em>.
                </template>
                <em v-else style="opacity: 0.5">{{ birthplace_search_placeholder }}</em>
              </template>
            </v-select>
            <b-container class="mt-3">
              <div v-if="isLoading" class="d-flex justify-content-center mb-3">
                <b-spinner variant="primary"></b-spinner>
              </div>
              <b-row v-else align-h="center">
                <b-col cols="5" class="p-0 m-0">
                  <b-button id="edit-birth-infos" class="w-100" @click="editBirthInfos" :disabled="!birthPlaceFilled || !birthDateFilled">Confirmer <span v-show="browser!='Firefox'">et accéder à mon certificat </span>2/2</b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-form-group>
        </b-form-group>
        <b-form-group v-else-if="firefoxLinkStep">
          <b-row align-h="center">
            <b-col cols="5" class="p-0 m-0" @click="toggleModal()">
              <b-button id="firefox-certificate-link" class="w-100" :to="{name: 'Certificate', params: { user: userId }}" target="_blank">Accéder à mon certificat</b-button>
            </b-col>
          </b-row>
        </b-form-group>
    </b-modal>
</template>

<script>
import Store from '@/store/index.js'
import api from '@/services/api.js'
import publicApi from '@/services/public.js'

export default {
    data () {
        return {
            genderOptions: [
                {value: 'MALE', text: 'Homme'},
                {value: 'FEMALE', text: 'Femme'},
            ],
            country: "france",
            birthplace_search: "",
            birthplace_list: [],
            isLoading: false,
            timeout: null,
            alternative_birth_date: "",
            form: {
                full_name: {
                    gender: null,
                    last_name: Store.getters.getUser().last_name,
                    birth_name: (!Store.getters.getUser().birth_name || Store.getters.getUser().birth_name=="null" || Store.getters.getUser().birth_name=="") ? "" : Store.getters.getUser().birth_name=="null",
                    first_name: Store.getters.getUser().first_name,
                },
                birth: {
                    birth_date: "",
                    birthplace: "",
                },
            },
            alert: {
              text:"",
              variant:"primary",
              dismissSecs: 5,
              dismissCountdown: 0,
            },
          firefoxLinkStep: false,
        }
    },
    computed: {
      userId() { return Store.getters.getUserId() },
      browser() {
        const userAgent = navigator.userAgent;
        let browser = "unkown";
        // Detect browser name
        browser = (/ucbrowser/i).test(userAgent) ? 'UCBrowser' : browser;
        browser = (/edg/i).test(userAgent) ? 'Edge' : browser;
        browser = (/googlebot/i).test(userAgent) ? 'GoogleBot' : browser;
        browser = (/chromium/i).test(userAgent) ? 'Chromium' : browser;
        browser = (/firefox|fxios/i).test(userAgent) && !(/seamonkey/i).test(userAgent) ? 'Firefox' : browser;
        browser = (/; msie|trident/i).test(userAgent) && !(/ucbrowser/i).test(userAgent) ? 'IE' : browser;
        browser = (/chrome|crios/i).test(userAgent) && !(/opr|opera|chromium|edg|ucbrowser|googlebot/i).test(userAgent) ? 'Chrome' : browser;
        browser = (/safari/i).test(userAgent) && !(/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i).test(userAgent) ? 'Safari' : browser;
        browser = (/opr|opera/i).test(userAgent) ? 'Opera' : browser;

        return browser;
      },
      step() {
        return Store.getters.getCheckIdentityStep()
      },
      birthplace_search_placeholder() {
        return this.country=="france" ? "Veuillez renseigner les premières lettres de votre ville de naissance" : "Veuillez renseigner les premières lettres de votre pays de naissance";
      },
      birthPlaceFilled() {
        return this.form.birth.birthplace!='' && this.form.birth.birthplace!=null;
      },
      birthDateFilled() {
        return this.form.birth.birth_date!='' && this.form.birth.birth_date!=null;
      },
      emptyBirthPlaceClass() {
        return !this.birthPlaceFilled? "invalid-input" : "";
      }
    },
    methods: {
        async checkFullName() {
          this.isLoading=true;
          
          await api.patch('/user/check_full_name', this.form.full_name)
          .then(()=> {
            Store.dispatch('update_nom_popup');
            Store.dispatch('update_gender', this.form.full_name.gender);
            this.$parent.showAlert(
              "Vos informations ont bien été enregistrées, elles seront traitées dans un délai de 72h.",
              "success"
            )
          }).catch(()=> {
            this.$parent.showAlert(
              "Une erreur a été rencontrée, veuillez vérifier votre genre, nom et prénom.",
              "danger"
            )
          });
          this.isLoading=false;
        },
        async editBirthInfos() {
          this.isLoading=true;
          let birth_date = this.form.birth.birth_date;
          let birthplace = this.form.birth.birthplace.value;
          
          await api.patch('user/update_birth_infos', 
            {
              "birth_date" : birth_date,
              "birthplace" : birthplace
            }
          )
          .then(() => {
            Store.dispatch('update_naissance_popup');
            this.$parent.showAlert(
              "Vos informations ont été enregistrées, vous pouvez désormais consulter votre certificat.",
              "success"
            )
            if(this.browser!="Firefox") {
              const routeData = this.$router.resolve({name: 'Certificate', params: { user: this.userId }});
              window.open(routeData.href, '_blank');
              this.toggleModal();
            }
            else {
              this.firefoxLinkStep=true;
            }
          }).catch(()=> {
            this.$parent.showAlert(
              "Une erreur a été rencontrée, veuillez vérifier les informations renseignées.",
              "danger"
            )
          });
          this.isLoading=false;
        },
        async getInseeList(search) {
          window.clearTimeout(this.timeout);
          search = search.normalize("NFD").replace(/[\u0300-\u036f]/g, "") // Retire tous les accents de la recherche
          this.timeout = await window.setTimeout(() => {
            let country = this.country
            if(search != "" && search != null) {
              this.clearBirthPlace();
              publicApi.post(`/insee_list`, {country, search})
              .then((response) => {
                this.birthplace_list = response.data;
              })
              }
          }, "500")
        },
        clearBirthPlace() {
          this.birthplace_list = [];
          this.form.birth.birthplace = "";
        },
        toggleModal() {
          this.$root.$emit("bv::toggle::modal", "identity-modal");
        },
    },
    watch: {
      alternative_birth_date () {
        let splittedDate = this.alternative_birth_date.split('/');
        this.form.birth.birth_date = (splittedDate.length==3 && splittedDate[2].length==4)? splittedDate.reverse().join('-') : ""
      }
    }
}
</script>

<style scoped>
 #identity-alert {
  top: 15px;
  right: 30px;
  height: 2rem;
 }
 .invalid-input {
  border-color: #CB2C30;
 }
  #select_birthplace {
    padding: auto;
    padding-left: 0px;
    padding-right: 0px;
  }
</style>
<style>
  #identity-modal #select_birthplace .vs__dropdown-toggle {
    border: none;
    padding-bottom: 0px;
  }
  #identity-modal #select_birthplace .vs__dropdown-toggle .vs__selected-options input {
    margin-top: 5px;
  }
  #identity-modal #select_birthplace .vs__dropdown-toggle .vs__selected-options input {
    margin-top: 0px;
  }
</style>
